import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
// img
import FooterLogoLight from "../../images/logo-light.png";

// Footer component displays website footer with company info, navigation links, and contact details
export default function Footer() {
    return (
        <>
            <footer className='footer-section'>
                <Container>
                    <Row className='justify-content-center'>
                        {/* Logo and company intro section */}
                        <Col md={10} lg={8} xl={3}>
                            <div className='text-center text-xl-start mb-5 mb-xl-0'>
                                <img src={FooterLogoLight} alt="Footer Logo" height={60} width={90}/>
                                <p className='text-white opacity-75 fs-15 mt-3'>
                                    Delivering trusted real estate solutions across residential, commercial, and investment markets. With experience and a client-first focus, we help you make confident decisions.
                                </p>
                                <h5>Follow Us</h5>
                                {/* Social Media Icons */}
                                <ul className='list-inline footer-icon-content'>
                                    <li className='list-inline-item'><Link to="https://www.facebook.com/share/1EqxqB7txi/?mibextid=qi2Omg" className='footer-icon icon-hover-primary'target='blank'><i className="bi bi-facebook"></i></Link></li>
                                    <li className='list-inline-item'><Link to="https://www.instagram.com/northbbcreek?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" className='footer-icon icon-hover-danger'target='blank'><i className="bi bi-instagram"></i></Link></li>
                                    <li className='list-inline-item'><Link to="https://www.threads.net/@northbbcreek" className='footer-icon icon-hover-dark' target='blank' ><i className="bi bi-threads"></i></Link></li>
                                    <li className='list-inline-item'><Link to="https://wa.me/18606820175" className='footer-icon icon-hover-success'target='blank'><i className="bi bi-whatsapp"></i></Link></li>
                                   <li className='list-inline-item'><Link to="https://youtu.be/-jQvxLeMnhU" className='footer-icon icon-hover-dark' target='blank' ><i className="bi bi-youtube"></i></Link></li>
                                </ul>
                            </div>
                        </Col>

                        {/* Navigation and contact sections */}
                        <Col xl={{ span: 8, offset: 1 }}>
                            <Row>
                                {/* About Us Links */}
                                <Col sm={6} md={4}>
                                   
                                   <div className="d-flex aling-item-center footer-contact-us">
                                            <div className="flex-shrink-0">
                                                <div className='avatar avatar-sm bg-soft-dark text-dark border border-soft-dark rounded-circle'>
                                                    <i className="bi bi-envelope fs-20"></i>
                                                </div>
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <h6 className='mb-0'>E-mail</h6>
                                                <Link to="mailto:trivikbuildersa@gmail.com" className='text-white opacity-75 fs-15'>admin@trivikbuilders.com</Link>
                                            </div>
                                        </div>

                                </Col>

                                {/* Support Links */}
                                <Col sm={6} md={4}>
                                    
                                    <div className="d-flex aling-item-center footer-contact-us">
                                            <div className="flex-shrink-0">
                                                <div className='avatar avatar-sm bg-soft-dark text-dark border border-soft-dark rounded-circle'>
                                                    <i className="bi bi-telephone fs-20"></i>
                                                </div>
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <h6 className='mb-0'>Contact</h6>
                                                <Link to="tel:8606820175" className='text-white opacity-75 fs-15'>+1 (860)682-0175</Link>
                                            </div>
                                        </div>
                                </Col>

                                {/* Contact Info */}
                                <Col md={4}>
                                    <div className='mt-4 mt-md-0'>
                                        <h5></h5>

                                        {/* Email */}
                                        {/* <div className="d-flex aling-item-center footer-contact-us">
                                            <div className="flex-shrink-0">
                                                <div className='avatar avatar-sm bg-soft-dark text-dark border border-soft-dark rounded-circle'>
                                                    <i className="bi bi-envelope fs-20"></i>
                                                </div>
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <h6 className='mb-0'>E-mail</h6>
                                                <Link to="mailto:hari@trivikbuilders.com" className='text-white opacity-75 fs-15'>hari@trivikbuilders.com</Link>
                                            </div>
                                        </div> */}

                                        {/* Phone */}
                                        

                                        {/* Address */}
                                        <div className="d-flex aling-item-center footer-contact-us">
                                            <div className="flex-shrink-0">
                                                <div className='avatar avatar-sm bg-soft-dark text-dark border border-soft-dark rounded-circle'>
                                                    <i className="bi bi-pin-map fs-20"></i>
                                                </div>
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <h6 className='mb-0'>Location</h6>
                                                <Link to="https://maps.app.goo.gl/FztCyH1voR3NrNur5" target='blank' className='text-white opacity-75 fs-15'>
                                                   North BB Creek Townhomes,Carlos G. Parker Boulevard, Taylor, Williamson Country,TX
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    {/* Divider */}
                    <hr className='mt-md-5 mb-4' />

                    {/* Bottom Footer */}
                    <Row>
                        <Col md={12}>
                            <div className='d-md-flex justify-content-md-between text-center text-md-start'>
                                <p className='mb-2 mb-md-0 text-white opacity-75'>
                                    Copyright © {new Date().getFullYear()}{" "}
                                    <Link to="https://triviktts.trivikbuilders.com/" target="_blank" className='text-white'>
                                        Trivik Builders
                                    </Link>. Crafted with <i className="bi bi-heart-fill text-danger"></i>
                                </p>
                                {/* <Link to="/" className='text-white opacity-75'>Term Condition & Policy</Link> */}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </>
    );
}
